import { tw } from 'utils/classnames'

type CardVariant = 'default' | 'elevated'

interface CardProps {
  variant?: CardVariant
  children: React.ReactNode
  className?: string
}

export const Card = (props: CardProps) => {
  const variantClasses: Record<CardVariant, string> = {
    default: 'border border-cf-sf-gray-600',
    elevated: 'shadow-cf-elevation-light-1 ',
  }

  return (
    <div
      className={tw(
        'rounded-4 flex flex-row flex-wrap items-center justify-start gap-2 p-6 min-[575px]:flex-col min-[575px]:items-start',
        variantClasses[props.variant || 'default'],
        props.className,
      )}
    >
      {props.children}
    </div>
  )
}
